import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as manualGuideService from "../../services/manual-guide.service";
import CustomPagination from "../../common/custompagination";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import { isDevMode } from "../../../../utils/commonfunction";
// import * as Yup from "yup";

const ManualGuideList = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Manual Guide", url: "" },
  ];


  useEffect(()=>{
    if(!isDevMode()){
      navigate('/admin/dashboard');
    }
  },[]);
  useEffect(() => {
    manualGuideService
      .List()
      .then((data) => {
        setDataLength(data.data.total_records);
        setList(data && data.data && data.data.list ? data.data.list : []);
        setPage(data && data.data && data.data.page ? data.data.page : 1);
        setLoader(false);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });

  }, [
    location
  ]);
  const goToEdit = (row) => {
    navigate(
      `/admin/manual-guide/edit/${row._id}`
    );
  };
  const goToView = (row) => {
    navigate(
      `/admin/manual-guide/view/${row._id}/general`
    );
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                Manual Guide
              </h6>
              {/* <div className="d-flex align-items-center">
                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/testimonial-management/testimonial/add`)
                  }
                >
                  {t("btn_add_new")}
                </button>
              </div> */}
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>

                    <th>
                      Title
                    </th>
                    <th>
                      Breadcrumb title
                    </th>
                    {/* <th>
                      Slug
                    </th> */}

                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={10}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr
                              key={i}
                            >

                              <td>
                                {row ? ((page - 1) * itemperpage) + i + 1 : null}
                              </td>


                              <td>
                                {row?.title ? (
                                  <div className="d-flex">
                                    {row?.title ? row.title : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>
                              <td>
                                {row?.breadcrumb_title ? (
                                  <div className="d-flex">
                                    {row?.breadcrumb_title ? row.breadcrumb_title : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>
                              {/* <td>
                                {row?.slug ? (
                                  <div className="d-flex">
                                    {row?.slug ? row.slug : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td> */}

                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      goToView(row);
                                    }}
                                  >
                                    {t("btn_view")}
                                  </button>

                                  <button
                                    className="btn ripple btn-success mlAction"
                                    onClick={() => {
                                      goToEdit(row);
                                    }}
                                  >
                                    {t("btn_edit")}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Restaurant",
                    path: "/admin/testimonial-management/testimonial/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManualGuideList;
